//COMPONENTE
import LoadingComponent from "@/main/components/shared/loading/loadingComponent";

//SERVICES
import { GetItemsBySupplierResponse } from "@/main/models/response";

//SCREENS/COMPONENTS/STYLES LOCAL
import ListPartSupplier from "./listPartSupplier/listPartSupplier";
import * as S from "./styles";
import InfiniteScroll from "react-infinite-scroll-component";

interface IModalTracking {
	isLoadingModalTracking: boolean;
	packTracking: GetItemsBySupplierResponse[] | null;
	infiniteScrollConfig?: {
		hasMore: boolean;
		fetchData: () => void;
		dataLength: number;
		isLoading: boolean;
		idScrollTarget?: string;
	} | null;
	orderNumber: string | null;
	ignoreHeight?: boolean;
}

function ModalTracking({
	isLoadingModalTracking,
	packTracking,
	infiniteScrollConfig,
	ignoreHeight = false,
}: IModalTracking) {
	function renderGrid() {
		return (
			<>
				{packTracking &&
					packTracking.map((item, index) => (
						<ListPartSupplier
							key={index}
							pack={{
								packNumber: item.packNumber,
								supplier: item.supplierName,
								trackingNumber: item.trackingCode,
								guidPackingTrackingDelivery: item.guidPackingTrackingDelivery,
								guidProcurementSupplier: item.guidProcurementSupplier,
								logisticCompanyName: item.logisticCompanyName,
								shippingCompanyLogo: item.shippingCompanyLogo,
								guidPackingTrackingReturn: item.guidPackingTrackingReturn,
								trackingCodeReturn: item.trackingCodeReturn,
								depth: item.depth,
								height: item.height,
								width: item.width,
								orderNumber: item.procurementCode,
								collectionDate: item.collectionDate,
								showShippingCompanyAddress: item.showShippingCompanyAddress,
							}}
							parts={item.parts}
						/>
					))}
			</>
		);
	}

	if (isLoadingModalTracking) return <LoadingComponent />;
	return (
		<S.Container>
			{infiniteScrollConfig ? (
				<div
					style={{
						height: ignoreHeight ? "auto" : "80vh",
						overflow: "auto",
						paddingRight: "15px",
					}}
					id="id-modal-scroll"
				>
					<InfiniteScroll
						style={{ overflowX: "hidden" }}
						dataLength={infiniteScrollConfig.dataLength}
						next={infiniteScrollConfig.fetchData}
						hasMore={infiniteScrollConfig.hasMore}
						loader={infiniteScrollConfig.isLoading ? <LoadingComponent /> : <></>}
						scrollableTarget={infiniteScrollConfig.idScrollTarget}
					>
						{renderGrid()}
					</InfiniteScroll>
				</div>
			) : (
				renderGrid()
			)}
		</S.Container>
	);
}
export default ModalTracking;
